// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { addPermissionsToUser } from './basicCreators';
import type { ThunkAction } from '../../types';

// DEPRECATED - Use `deleteUserFromOrganisation` instead
export function removeUserFromOrganisation(
  user: Object,
  organisationId: number,
  userOrganisationId: number
): ThunkAction {
  return function(dispatch, getState) {
    const uoid = userOrganisationId
      ? userOrganisationId
      : user.userOrganisationId;

    const endpoint = `/user/organisation/${uoid}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: { isArchived: true }
    };

    return makeAPICall(endpoint, options).then(
      response => response,
      error =>
        dispatch(APIError(error, 'Error removing User from Organisation'))
    );
  };
}

export function deleteUserFromOrganisation(
  userId: number, // ID of the User that is being removed
  userOrganisationId: number // ID of the target Organisation
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/organisations/${userOrganisationId}/users/${userId}?`;
    const options = {
      method: 'DELETE',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId: userOrganisationId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => response,
      error =>
        dispatch(APIError(error, 'Error removing User from Organisation'))
    );
  };
}

export function getAllocatedUserOrganisations(
  userId: number,
  organisationId: number
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/user/organisations/${userId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        dispatch({
          type: 'GET_ALLOCATED_USER_ORGANISATIONS',
          organisations: response.data
        });
      },
      error =>
        dispatch(APIError(error, 'Error getting allocated user organisations'))
    );
  };
}

export function getUnallocatedUserOrganisations(
  userId: number,
  organisationId: number
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/user/organisation/settings/${userId}`;
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        dispatch({
          type: 'GET_UNALLOCATED_USER_ORGANISATIONS',
          organisations: response.data
        });
      },
      error =>
        dispatch(
          APIError(error, 'Error getting unallocated user organisations')
        )
    );
  };
}

export function addUserOrganisation(
  userId: number,
  organisationId: number,
  newOrganisationId: number,
  newOrganisationName: number,
  isAdmin: boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    const permissions = [
      {
        permissionId: 1,
        permissionName: 'User'
      }
    ];
    if (isAdmin) {
      permissions.push({
        permissionId: 2,
        permissionName: 'Admin'
      });
    }

    const endpoint = `/user/organisations`;
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: {
        userId,
        organisationId: newOrganisationId,
        organisationName: newOrganisationName,
        permissions
      }
    };

    return makeAPICall(endpoint, options).then(
      response => {
        return response;
      },
      error => dispatch(APIError(error, 'Error adding new user organisation'))
    );
  };
}

export function addUserToOrganisation(
  user: Object,
  organisationId: number,
  settings: any
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/user/organisations`;
    let options;

    if (settings) {
      user = addPermissionsToUser(user, settings);
      options = {
        method: 'POST',
        headers: { token: getState().authentication.token },
        params: {
          productId: config.productId,
          organisationId
        },
        data: {
          userId: user.id,
          organisationId,
          permissions: user.permissions
        }
      };
    } else {
      options = {
        method: 'POST',
        headers: { token: getState().authentication.token },
        params: {
          productId: config.productId,
          organisationId
        },
        data: {
          userId: user.id,
          organisationId,
          permissions: [
            {
              permissionId: 1,
              permissionName: 'User'
            }
          ]
        }
      };
    }

    return makeAPICall(endpoint, options).then(
      response => response,
      error => dispatch(APIError(error, 'Error adding new user organisation'))
    );
  };
}

export function updateUserOrganisation(
  userOrganisationId: number,
  organisationId: number,
  isArchived: any = undefined,
  permissions: any = undefined
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = `/user/organisation/${userOrganisationId}`;
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId
      },
      data: {
        isArchived,
        permissions
      }
    };

    return makeAPICall(endpoint, options).then(
      response => response,
      error => dispatch(APIError(error, 'Error updating UserOrganisation'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/users/organisationCreators.js